import LocationTypeLabel from '@/components/Geography/LocationTypeLabel';
import SearchIconAlt from '@/components/Icons/SearchIconAlt';
import { Autocomplete, InputAdornment, TextField } from '@mui/material';
import PropTypes from 'prop-types';

const GeoTargeting = ({
  selectedLocations = [],
  loadingLookup,
  loading,
  onValuesPaste,
  onOpen,
  onClose,
  query,
  suggestions,
  handleInput,
  handleKeyDown,
  onChange,
  open,
  id,
  placeholder,
}) => {
  return (
    <Autocomplete
      id={id}
      multiple
      fullWidth
      disableClearable
      disableCloseOnSelect
      filterSelectedOptions
      size='small'
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      value={selectedLocations}
      loading={loadingLookup || loading}
      inputValue={query}
      options={suggestions}
      onInputChange={handleInput}
      onChange={onChange}
      onKeyDown={handleKeyDown}
      filterOptions={x => x}
      getOptionLabel={option => option?.displayName || ''}
      isOptionEqualToValue={(option, selectValue) => selectValue && option.id === selectValue?.id}
      renderTags={() => null}
      noOptionsText='Type to search'
      renderInput={params => (
        <TextField
          {...params}
          placeholder={placeholder}
          onPaste={onValuesPaste}
          variant='outlined'
          slotProps={{
            input: {
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position='start'>
                  <SearchIconAlt />
                </InputAdornment>
              ),
            },
          }}
        />
      )}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.id}>
            <span className='mr-auto'>{option.displayName}</span>
            <LocationTypeLabel className='ml-4' locationType={option.type} />
          </li>
        );
      }}
    />
  );
};

GeoTargeting.propTypes = {
  selectedLocations: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired,
      apiName: PropTypes.string.isRequired,
      country: PropTypes.string,
    }),
  ),
  loadingLookup: PropTypes.bool,
  loading: PropTypes.bool,
  query: PropTypes.string,
  suggestions: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired,
      apiName: PropTypes.string.isRequired,
      country: PropTypes.string,
    }),
  ),
  open: PropTypes.bool,
  handleInput: PropTypes.func,
  handleKeyDown: PropTypes.func,
  onChange: PropTypes.func,
  onValuesPaste: PropTypes.func,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
};

export default GeoTargeting;
